import type { RouteRecordRaw } from "vue-router"
import { useApplicationStore } from "@versatile-credit-apply/sdk"

export const KafeneDecisionRoutes: RouteRecordRaw[] = [
  {
    name: "kafene-apply-approved",
    path: "approved",
    component: () => import("./components/KafeneApproved.vue"),
  },
  {
    name: "kafene-apply-declined",
    path: "declined",
    component: () => import("./components/KafeneDeclined.vue"),
  },
  {
    name: "kafene-apply-pending",
    path: "pending",
    component: () => import("./components/KafenePending.vue"),
  },
  {
    name: "kafene-apply-error",
    path: "error",
    component: () => import("./components/KafeneError.vue"),
  },
  {
    name: "kafene-apply-nooffer",
    path: "nooffer",
    component: () => import("./components/KafeneNoOffer.vue"),
  },
  {
    name: "kafene-apply-prequalified",
    path: "prequalified",
    component: () => import("./components/KafenePrequalified.vue"),
    meta: {
      next: "../application",
      step: "applicant",
    },
  },
]

export const KafeneApplyRoutes: RouteRecordRaw[] = [
  {
    name: "kafene-apply-routes",
    path: "kafene_standard",
    children: [
      {
        name: "kafene-terms",
        path: "terms",
        component: () => import("./pages/KafeneTermsAndConditionsPage.vue"),
        meta: {
          next: () => {
            const store = useApplicationStore()
            return store.applyMode !== "full" ? "accept-offer" : "submit"
          },
          step: "terms",
        },
      },
      {
        name: "kafene-apply-start",
        path: "start/:mode",
        component: () => import("./pages/KafeneIntroPage.vue"),
        meta: {
          step: "applicant",
        },
      },
      {
        name: "kafene-apply-decisions",
        path: "decision",
        component: () => import("./pages/KafeneDecisionPage.vue"),
        meta: {
          preventBack: true,
          step: "decision",
        },
        children: [...KafeneDecisionRoutes],
      },
    ],
  },
]
